var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"large":"","rounded":"","color":"#36adb5","to":"dapp"}},[_c('v-icon',{staticClass:"me-2",attrs:{"size":20}},[_vm._v("mdi-play-circle-outline")]),_vm._v(" Open App ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }